(() => {
    if (!document.getElementById('applicationForm')) {
        return;
    }
    $(document).on('change', 'select[name="employment_industry"]', function (e) {
        let selectedIndustry = e.target.value
        let target = $('select[name="employment_noc"]')
        target.find('option').prop('selected', false)
        target.find('optgroup').removeClass('d-none')
        target.find('optgroup[label!="' + selectedIndustry + '"]').addClass('d-none')
    });

    let selectedIndustry = $('select[name="employment_industry"]').val()
    let target = $('select[name="employment_noc"]')
    target.find('optgroup').removeClass('d-none')
    target.find('optgroup[label!="' + selectedIndustry + '"]').addClass('d-none')
})();
